import Saves from 'components/Saves';
import Navigation from 'components/Navigation';
import Copyright from 'components/Copyright';
import Page, { Content, Footer } from 'containers/Page';
import { Paragraph } from 'elements/Text';


const SavesPage = () => {
  return (
    <Page>
      <Content>
        <Navigation />
        <Paragraph>Your Crosswords:</Paragraph>
        <Saves />
      </Content>
      <Footer>
        <Copyright />
      </Footer>
    </Page>
  );
}

export default SavesPage;
